import { render } from "./OverallScores.vue?vue&type=template&id=a8ae373a&scoped=true"
import script from "./OverallScores.vue?vue&type=script&lang=js"
export * from "./OverallScores.vue?vue&type=script&lang=js"

import "./OverallScores.vue?vue&type=style&index=0&id=a8ae373a&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ae373a"]])

export default __exports__